import { IProduct } from '../types';
import { Fetch } from './Fetch';

export const Product = {
	getList: (): Promise<IProduct[]> => Fetch.get(`/management/products`)
}
